import { UseFetchOptions } from '@shared/fetch-utils';
import { handleTokenRefresh } from './handleTokenRefresh';

export class ErrorWithPayload extends Error {
  readonly payload: any;

  constructor(message: string, payload: any) {
    super(message);
    this.name = 'ErrorWithPayload';
    this.payload = payload;
  }
}

const transformToError = (error: any) => {
  if (error instanceof Error) {
    return error;
  }

  return new ErrorWithPayload(error.message || error.details || 'Fetch error', error);
};

type OnRejected<T> = (error: any, retryRequest: (retryProps: UseFetchOptions) => Promise<T>) => any;

export const handleFetchErrorWithTokenRefresh =
  <T>(refreshFunction: () => Promise<string>, requestOptions: any): OnRejected<T> =>
  async (error, retryRequest) => {
    if (error.status === 401) {
      try {
        const newToken = await handleTokenRefresh(refreshFunction);
        return await retryRequest({
          ...requestOptions,
          token: newToken,
        });
      } catch (refreshError) {
        console.error('Failed to refresh token', refreshError);
        throw refreshError;
      }
    }
    throw transformToError(error);
  };
